<template>
    <div class="login-container">
        <div class="login-box">
            <h2>植物大战僵尸</h2>
            <div class="form-group">
                <input v-model="username" type="text" placeholder="用户名" required />
            </div>
            <div class="form-group">
                <input v-model="password" type="password" placeholder="密码" required />
            </div>
            <button @click="handleLogin" class="login-btn">登录</button>
            <div class="links">
                <router-link to="/register">还没有账号？立即注册</router-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'LoginView',
    data() {
        return {
            username: '',
            password: '',
        };
    },
    methods: {
        async handleLogin() {
            try {
                const response = await fetch('/api/auth/login', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        username: this.username,
                        password: this.password,
                    }),
                });

                const data = await response.json();

                if (response.ok) {
                    localStorage.setItem('token', data.token);
                    this.$store.commit('setUser', data.user);
                    this.$router.push('/game');
                } else {
                    alert(data.message || '登录失败');
                }
            } catch (error) {
                console.error('登录错误:', error);
                alert('登录失败，请稍后重试');
            }
        },
    },
};
</script>

<style scoped lang="scss">
.login-container {
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background: url('../assets/images/background.jpg') no-repeat center center;
    background-size: cover;
}

.login-box {
    background: rgba(255, 255, 255, 0.9);
    padding: 2rem;
    border-radius: 8px;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
    width: 300px;

    h2 {
        color: #2c3e50;
        margin-bottom: 2rem;
    }
}

.form-group {
    margin-bottom: 1rem;

    input {
        width: 100%;
        padding: 0.8rem;
        border: 1px solid #ddd;
        border-radius: 4px;
        font-size: 1rem;

        &:focus {
            outline: none;
            border-color: #42b983;
        }
    }
}

.login-btn {
    width: 100%;
    padding: 0.8rem;
    background: #42b983;
    color: white;
    border: none;
    border-radius: 4px;
    font-size: 1rem;
    cursor: pointer;
    transition: background 0.3s;

    &:hover {
        background: #3aa876;
    }
}

.links {
    margin-top: 1rem;

    a {
        color: #42b983;
        text-decoration: none;

        &:hover {
            text-decoration: underline;
        }
    }
}
</style>
